<template>
  <div id="elitefit-social">
    <div class="social-notification-layer social">
      <div class="loading-layer social">
        <span class="pl-5 position-fixed z-index-10" v-if="!hideBackButton"> <b-icon icon="arrow-left" class="cursor-pointer" @click="goBack" font-scale="1.8"></b-icon></span>
        <router-view v-if="renderChild" :key="$route.fullPath"/>
      </div>
      <div class="loading-layer loading">
        <div class="loading-spinner">
          <b-spinner v-if="!dataFetched" variant="success" type="grow" label="Loading"></b-spinner>
        </div>
      </div>
    </div>
    <div class="social-notification-layer notification">
      <NotificationCenter ref="noticeRef" :base-z-index="3" :offset-box="offsetBox"/>
    </div>
  </div>
</template>
<script>
import NotificationCenter, {POSITIONS} from "@/module_social/components/notification/NotificationCenter";
import {createNamespacedHelpers} from "vuex";
import MESSAGES from "@/module_social/models/messages";
const {
  mapState: socialState,
  mapActions: socialActions,
  mapMutations: socialMutations,
  mapGetters: socialGetters,
} = createNamespacedHelpers("social");
const {
  mapActions: b2bActions
} = createNamespacedHelpers("b2bUser");

export default {
  components: {
    NotificationCenter
  },
  data() {
    return {
      dataFetched: false,
      offsetBox: {
        offsetTop: 5,
        offsetBottom: 15,
        offsetLeft: 15,
        offsetRight: 15,
      }
    }
  },
  computed: {
    ...socialState(["isLoggedIn", "socialService"]),

    renderChild() {
      return this.isLoggedIn && this.dataFetched;
    },
    hideBackButton() {
      let hideOnPages = ['SocialFeed'];
      let activePage = this.$route.name;
      return hideOnPages.includes(activePage);
    }
  },
  methods: {
    ...b2bActions(["setIsTitle", "setTitle"]),
    ...socialActions(["authenticate", "updateProfile", "userMeta", "nextPostCategories", "fetchReportCategories"]),

    addNotice(notice, position, persistent=false) {
      this.$refs.noticeRef.addNotice(notice, position, persistent);
    },
    goBack() {
      this.$router.push({name: 'SocialFeed'});
    },
  },
  async mounted() {
    this.setIsTitle(true);
    this.setTitle("Social");

    if (this.isLoggedIn) {
      this.dataFetched = true;
      return;
    };
    this.dataFetched = false;
    try {
      await this.authenticate();
      // don't throw error, fail gracefully.
      await this.updateProfile().catch(error => Promise.resolve(error));
      await this.userMeta().catch(error => {
        this.addNotice({
          title: MESSAGES.SOCIAL_FETCH_INFO_FAILED,
          type: 'error',
          closeOnClick: true,
          duration: 3000,
        }, POSITIONS.TOP);
        return Promise.resolve(error);
      });
      try {
        await this.nextPostCategories();
        await this.fetchReportCategories();
      } catch (e) {
        this.$log.error("Failed to fetch categories information: ", e);
      }
    } catch (error) {
      this.addNotice({
        title: MESSAGES.SOCIAL_AUTH_FAILED,
        type: 'error',
        closeOnClick: true,
        duration: 3000,
      }, POSITIONS.TOP);
    } finally {
      this.dataFetched = true;
    }
    console.log("socialLayoutMounted");
  },
  beforeDestroy() {
    this.setIsTitle(false);
    this.setTitle("");
  },
}

</script>
<style lang="scss">
@import "@/assets/style/_social.scss";
#elitefit-social {
  height: 100%;
  position: relative;
}

.social-notification-layer {
  &.social {
    position: relative;
    height: 100%;
  }
  &.notification {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;
    pointer-events: none;
  }
}

.loading-layer {
  &.social {
    position: relative;
    height: 100%;
  }
  &.loading {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    pointer-events: none;
  }
}

.loading-spinner {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $main-color !important;
  height: 100%;
}
</style>